/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-26T15:10:34-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-19T11:58:28-07:00
*/



import React, { Component } from 'react';
import Avatar from '../../common/Avatar';
import Button from '../../blocks/Button';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Link } from 'react-router';
import { dimensions, spacing, type, borders, color, textColor, size } from '../../../style';
import { tsYears } from '../../../common';

const style = StyleSheet.create({
  resultItem: {
    ...textColor.DARKER,
    display: 'flex',
    alignItems: 'center',
    ...spacing.PADDING_MD,
    borderBottom: borders.DEFAULT,

    [dimensions.SCREEN_MIN_MD]: {
      ':hover': {
        backgroundColor: color.GREY_LIGHTEST
      }
    },

    [dimensions.SCREEN_MAX_SM]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      ...spacing.PADDING_SM
    }
  },
  resultView: {
    flexGrow: '1',
    display: 'flex'
  },
  resultThumb: {
    ...size.SIZE_80X80,
    ...spacing.MARGIN_RIGHT_MD,
    flex: '0 0 70px'
  },
  title: {
    ...type.title.XS
  },

  timeStamp: {
    ...spacing.MARGIN_TOP_XS
  },

  resultDetails: {
    [dimensions.SCREEN_MAX_SM]: {
      ...spacing.MARGIN_BOTTOM_SM
    }
  },

  resultActions: {
    [dimensions.SCREEN_MAX_SM]: {
      paddingLeft: 88
    }
  },
  meta: {
    ...type.SM,
    ...textColor.NORMAL,
    ...spacing.MARGIN_BOTTOM_XS
  }
});

class UserItem extends Component {

  constructor(props) {
    super(props);
    this.isFavorite = this.isFavorite.bind(this);
  }

  isFavorite(isFav) {
    if(isFav) {
      // user is already favorited
      return (
        <Button variant="primary" onClick={() => {this.props.toggle(this.props.title,this.props.favKey)}}>
          <svg width="18" height="18" viewBox="0 0 30 30">
            <path fill="#fff" d="M10.2732671,9.66666667 L13.5174678,0.845833333 C13.7626601,0.3625 14.2530447,0 14.7434293,0 C15.233814,0 15.7241986,0.3625 15.8467947,0.845833333 L19.0909955,9.66666667 L28.2290063,9.66666667 C28.7193909,9.66666667 29.2097755,10.0291667 29.4549678,10.5125 C29.577564,10.9958333 29.4549678,11.6 28.9645832,11.8416667 L21.9290254,16.9341115 L25.7770832,27.3083333 C26.0222755,27.7916667 25.7770832,28.3958333 25.4092947,28.6375 C25.0415063,28.8791667 24.796314,29 24.5511217,29 C24.3059293,29 24.060737,28.8791667 23.8155447,28.7583333 L14.6821313,22.1192969 L5.54871781,28.7583333 C5.42612166,28.8791667 5.18092935,29 4.93573704,29 C4.69054473,29 4.44535243,28.8791667 4.20016012,28.7583333 C3.7097755,28.3958333 3.58717935,27.9125 3.83237166,27.4291667 L7.63285243,17.0375 L0.522275502,11.8416667 C0.154487041,11.4791667 -0.0907052668,10.9958333 0.0318908871,10.5125 C0.277083195,10.0291667 0.76746781,9.66666667 1.25785243,9.66666667 L10.2732671,9.66666667 L10.2732671,9.66666667 Z M12.1392522,11.5066657 C12.2008198,11.4240717 12.2524001,11.3338596 12.2915063,11.2375 L14.7434293,4.7125 L17.1953524,11.2375 C17.3179486,11.7208333 17.8083332,12.0833333 18.2987178,12.0833333 L18.5439101,12.0833333 L24.5511217,12.0833333 L19.9397168,15.3785287 C19.7723322,15.4579677 19.6257818,15.5740454 19.5083833,15.7130985 C19.1369314,16.1193569 19.0719407,16.8453061 19.4020832,17.2791667 C19.4075022,17.2871783 19.4129811,17.2950719 19.4185185,17.3028487 L21.9766024,24.4083333 L15.4790063,19.6958333 C15.2609515,19.5346438 14.9701763,19.4690205 14.6821313,19.4883398 C14.3940862,19.4690205 14.1033111,19.5346438 13.8852563,19.6958333 L7.38766012,24.4083333 L10.2073717,16.9166667 C10.452564,16.4333333 10.3299678,15.95 9.83958319,15.5875 L4.93573704,12.0833333 L11.0655447,12.0833333 C11.5576746,12.0833333 11.9400531,11.8669867 12.1392522,11.5066657 L12.1392522,11.5066657 Z" id="Combined-Shape"></path>
          </svg>
          &nbsp; Favorited
        </Button>
      );
    } else {
      // user isn't favorited yet.
      return (
        <Button variant="simple" onClick={() => {this.props.toggle(this.props.title,this.props.favKey)}}>
          <svg width="18" height="18" viewBox="0 0 30 30">
            <path fill="#ccc" d="M10.2732671,9.66666667 L13.5174678,0.845833333 C13.7626601,0.3625 14.2530447,0 14.7434293,0 C15.233814,0 15.7241986,0.3625 15.8467947,0.845833333 L19.0909955,9.66666667 L28.2290063,9.66666667 C28.7193909,9.66666667 29.2097755,10.0291667 29.4549678,10.5125 C29.577564,10.9958333 29.4549678,11.6 28.9645832,11.8416667 L21.9290254,16.9341115 L25.7770832,27.3083333 C26.0222755,27.7916667 25.7770832,28.3958333 25.4092947,28.6375 C25.0415063,28.8791667 24.796314,29 24.5511217,29 C24.3059293,29 24.060737,28.8791667 23.8155447,28.7583333 L14.6821313,22.1192969 L5.54871781,28.7583333 C5.42612166,28.8791667 5.18092935,29 4.93573704,29 C4.69054473,29 4.44535243,28.8791667 4.20016012,28.7583333 C3.7097755,28.3958333 3.58717935,27.9125 3.83237166,27.4291667 L7.63285243,17.0375 L0.522275502,11.8416667 C0.154487041,11.4791667 -0.0907052668,10.9958333 0.0318908871,10.5125 C0.277083195,10.0291667 0.76746781,9.66666667 1.25785243,9.66666667 L10.2732671,9.66666667 L10.2732671,9.66666667 Z M12.1392522,11.5066657 C12.2008198,11.4240717 12.2524001,11.3338596 12.2915063,11.2375 L14.7434293,4.7125 L17.1953524,11.2375 C17.3179486,11.7208333 17.8083332,12.0833333 18.2987178,12.0833333 L18.5439101,12.0833333 L24.5511217,12.0833333 L19.9397168,15.3785287 C19.7723322,15.4579677 19.6257818,15.5740454 19.5083833,15.7130985 C19.1369314,16.1193569 19.0719407,16.8453061 19.4020832,17.2791667 C19.4075022,17.2871783 19.4129811,17.2950719 19.4185185,17.3028487 L21.9766024,24.4083333 L15.4790063,19.6958333 C15.2609515,19.5346438 14.9701763,19.4690205 14.6821313,19.4883398 C14.3940862,19.4690205 14.1033111,19.5346438 13.8852563,19.6958333 L7.38766012,24.4083333 L10.2073717,16.9166667 C10.452564,16.4333333 10.3299678,15.95 9.83958319,15.5875 L4.93573704,12.0833333 L11.0655447,12.0833333 C11.5576746,12.0833333 11.9400531,11.8669867 12.1392522,11.5066657 L12.1392522,11.5066657 Z" id="Combined-Shape"></path>
          </svg>
          &nbsp; Favorite
        </Button>
      );
    }
  }

  render () {

    return (
    <div className={css(style.resultItem)}>
      <Link className={css(style.resultView)} to={`/~${this.props.title}`}>
        <div className={css(style.resultThumb)}>
          <Avatar src={this.props.avatar} />
        </div>
        <div className={css(style.resultDetails)}>
          <div className={css(style.title)}>{this.props.title}</div>
          <div className={css(style.meta)}>{this.props.age} ･ {this.props.city}, {this.props.region}, {this.props.country}</div>
          <div className={css(style.userDescription)}>{this.props.description ? this.props.description.substring(0, 80) : ''}</div>
          <div className={css(style.timeStamp)}>{this.props.timeStamp}</div>
        </div>
      </Link>
      <div className={css(style.resultActions)}>
        {this.isFavorite(this.props.isFavorite)}
      </div>
    </div>
  )};
}



export default UserItem;



// WEBPACK FOOTER //
// ./src/components/pages/Search/UserItem.jsx